
// import React, { useEffect, useState } from "react";
// import styles from "./VenuePopup.module.css";

// const API_BASE = "";
// const POPUP_API = `${API_BASE}/api/venue-popup/`;

// const CALL_PHONE = "919971881444";
// const VENUE_PLANNER_URL = "/venue-planner";

// export default function VenuePopup({ hotels = [] }) {
//   const [cta, setCta] = useState("");
//   const [hotel, setHotel] = useState(null);
//   const [isVisible, setIsVisible] = useState(true);

//   useEffect(() => {
//     let cancelled = false;

//     async function fetchPopupData() {
//       try {
//         const response = await fetch(POPUP_API);

//         if (!response.ok) {
//           throw new Error("Unable to load popup data");
//         }

//         const popupData = await response.json();

//         if (cancelled) return;

//         const popup = Array.isArray(popupData)
//           ? popupData[0]
//           : popupData;

//         const messages = (popup?.text || "")
//           .split(",")
//           .map((item) => item.trim())
//           .filter(Boolean);

//         if (messages.length > 0) {
//           const randomCTA =
//             messages[Math.floor(Math.random() * messages.length)];

//           setCta(randomCTA);
//         }
//       } catch (error) {
//         console.error("Venue popup error:", error);
//       }
//     }

//     fetchPopupData();

//     return () => {
//       cancelled = true;
//     };
//   }, []);

//   useEffect(() => {
//     const hotelList = Array.isArray(hotels)
//       ? hotels
//       : hotels?.results || [];

//     const hotelsWithImages = hotelList.filter(
//       (item) => item.featured_image
//     );

//     if (hotelsWithImages.length > 0) {
//       const randomHotel =
//         hotelsWithImages[
//           Math.floor(Math.random() * hotelsWithImages.length)
//         ];

//       setHotel(randomHotel);
//     } else {
//       setHotel(null);
//     }
//   }, [hotels]);

//   if (!isVisible || !cta) return null;

//   const imageUrl = hotel?.featured_image
//     ? hotel.featured_image.startsWith("http")
//       ? hotel.featured_image
//       : `${API_BASE.replace(/\/$/, "")}/${hotel.featured_image.replace(
//           /^\//,
//           ""
//         )}`
//     : null;

//   return (
//     <aside className={styles.strip} aria-label="Venue planner promotion">
//       <button
//         type="button"
//         className={styles.closeButton}
//         onClick={() => setIsVisible(false)}
//         aria-label="Close promotion"
//       >
//         &times;
//       </button>

//       {imageUrl && (
//         <img
//           src={imageUrl}
//           alt={hotel?.name || "Premium hotel"}
//           className={styles.image}
//           loading="lazy"
//         />
//       )}

//       <div className={styles.message} title={cta}>
//         {cta}
//       </div>

//       <div className={styles.ctButtons}>
//         <a
//           href={`tel:+${CALL_PHONE}`}
//           className={styles.iconButton}
//           aria-label="Call us"
//           title="Call us"
//         >
//           <svg
//             viewBox="0 0 24 24"
//             width="18"
//             height="18"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             aria-hidden="true"
//           >
//             <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 11.2 18a19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 3.18 2 2 0 0 1 4.07 1h3a2 2 0 0 1 2 1.72c.12.96.36 1.9.7 2.8a2 2 0 0 1-.45 2.11L8.05 8.9a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.84.58 2.8.7A2 2 0 0 1 22 16.92Z" />
//           </svg>
//         </a>

//         <a
//           href={VENUE_PLANNER_URL}
//           className={`${styles.iconButton} ${styles.exploreIcon}`}
//           aria-label="Explore venues"
//           title="Explore venues"
//         >
//           <svg
//             viewBox="0 0 24 24"
//             width="20"
//             height="20"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             aria-hidden="true"
//           >
//             <path d="M5 12h14" />
//             <path d="m12 5 7 7-7 7" />
//           </svg>
//         </a>
//       </div>
//     </aside>
//   );
// }


import React, { useEffect, useState } from "react";
import styles from "./VenuePopup.module.css";

// Empty fallback means same-origin API in production.
const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

const POPUP_API = `${API_BASE}/api/venue-popup/`;
const HOTELS_API = `${API_BASE}/api/venue-planner/`;

const CALL_PHONE = "919971881444";
const VENUE_PLANNER_URL = "/venue-planner";

export default function VenuePopup() {
  const [cta, setCta] = useState("");
  const [hotel, setHotel] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchPopupData() {
      try {
        // Fetch CTA and hotel data together.
        const [popupResponse, hotelsResponse] = await Promise.all([
          fetch(POPUP_API),
          fetch(HOTELS_API),
        ]);

        if (!popupResponse.ok) {
          throw new Error(
            `Popup API failed: ${popupResponse.status}`
          );
        }

        if (!hotelsResponse.ok) {
          throw new Error(
            `Hotels API failed: ${hotelsResponse.status}`
          );
        }

        const [popupData, hotelsData] = await Promise.all([
          popupResponse.json(),
          hotelsResponse.json(),
        ]);

        if (cancelled) return;

        // Select a random CTA.
        const popup = Array.isArray(popupData)
          ? popupData[0]
          : popupData;

        const messages = (popup?.text || "")
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);

        if (messages.length > 0) {
          const randomCTA =
            messages[Math.floor(Math.random() * messages.length)];

          setCta(randomCTA);
        }

        // Support array and paginated API responses.
        const hotels = Array.isArray(hotelsData)
          ? hotelsData
          : hotelsData?.results || [];

        const hotelsWithImages = hotels.filter(
          (item) =>
            typeof item.featured_image === "string" &&
            item.featured_image.trim() !== ""
        );

        if (hotelsWithImages.length > 0) {
          const randomHotel =
            hotelsWithImages[
              Math.floor(Math.random() * hotelsWithImages.length)
            ];

          setHotel(randomHotel);
        } else {
          setHotel(null);
        }
      } catch (error) {
        console.error("Venue popup error:", error);
      }
    }

    fetchPopupData();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!isVisible || !cta) return null;

  // Normalize hotel image URLs for the HTTPS website.
  const imageUrl = hotel?.featured_image
    ? (() => {
        const rawUrl = hotel.featured_image.trim();

        if (/^https?:\/\//i.test(rawUrl)) {
          try {
            const parsedUrl = new URL(rawUrl);

            if (
              parsedUrl.hostname === "www.atlastravelhouse.com" ||
              parsedUrl.hostname === "atlastravelhouse.com"
            ) {
              parsedUrl.protocol = "https:";
              parsedUrl.hostname = "atlastravelhouse.com";
            }

            return parsedUrl.href;
          } catch {
            return null;
          }
        }

        return `${API_BASE}/${rawUrl.replace(/^\/+/, "")}`;
      })()
    : null;

  return (
    <aside
      className={styles.strip}
      aria-label="Venue planner promotion"
    >
      <button
        type="button"
        className={styles.closeButton}
        onClick={() => setIsVisible(false)}
        aria-label="Close promotion"
      >
        &times;
      </button>

      {imageUrl && (
        <img
          src={imageUrl}
          alt={hotel?.name || "Premium hotel"}
          className={styles.image}
          loading="lazy"
          onError={() => setHotel(null)}
        />
      )}

      <div className={styles.message} title={cta}>
        {cta}
      </div>

      <div className={styles.ctButtons}>
        <a
          href={`tel:+${CALL_PHONE}`}
          className={styles.iconButton}
          aria-label="Call us"
          title="Call us"
        >
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 11.2 18a19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 3.18 2 2 0 0 1 4.07 1h3a2 2 0 0 1 2 1.72c.12.96.36 1.9.7 2.8a2 2 0 0 1-.45 2.11L8.05 8.9a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.84.58 2.8.7A2 2 0 0 1 22 16.92Z" />
          </svg>
        </a>

        <a
          href={VENUE_PLANNER_URL}
          className={`${styles.iconButton} ${styles.exploreIcon}`}
          aria-label="Explore venues"
          title="Explore venues"
        >
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </a>
      </div>
    </aside>
  );
}
